import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/memberCard/page', data, {
    trim: true
  })
}

// 创建
export function create (data) {
  return request.post('/business/memberCard/create', data)
}

// 根据类型查询人员信息
export function findTypeMemberInfo (data) {
  return request.post('/business/member/findTypeMemberInfo', data)
}

// 退卡操作
export function refundCard (data) {
  return request.post('/business/memberCard/refundCard', data)
}

// 挂失
export function batchLoss (data) {
  return request.post('/business/memberCard/batchLoss', data)
}

// 解挂
export function batchUnLoss (data) {
  return request.post('/business/memberCard/batchUnLoss', data)
}
